import { useHandleEndLiveChat } from 'components/App/hooks/useHandleEndLiveChat';
import { OrgThemedButton } from 'components/OrgThemedButton';
import { INPUT_BORDER_RADIUS } from 'embed/constants';
import { Box } from '@mui/material';

export const RestartChatButton = () => {
  const handleEndLiveChat = useHandleEndLiveChat({
    /**
     * We don't want to send "User left the chat" message because it should've been
     * sent already when the end user ended the chat
     */
    shouldSendUserLeftMessage: false,
  });

  return (
    <Box sx={{ boxSizing: 'border-box', width: '100%' }}>
      <OrgThemedButton
        fullWidth
        onClick={handleEndLiveChat}
        sx={{
          borderRadius: INPUT_BORDER_RADIUS,
        }}
        variant='contained'
      >
        Start new chat
      </OrgThemedButton>
    </Box>
  );
};
